import { Helmet } from "react-helmet-async";
import { useState, useEffect } from "react";
import { toast } from "react-toastify";
// @mui
import { useTranslation } from "react-i18next";
import { Stack, Button, Skeleton, Grid, FormControl, Select, MenuItem, Typography, Box } from "@mui/material";
import CityReqTable from "../sections/@dashboard/askRequests/DataTable";
import SearchComponet from "../components/search/Search";

import { getAskRequestsList, deleteAskRequest, getLookupsList } from "../network/apis";
import AddOrEditModal from "../sections/@dashboard/askRequests/Modal";
import ConfirmationModal from "../components/confirmationModal/ConfirmationModal";
import { ReactComponent as DropdownIcon } from "../theme/images/deopdownIcon.svg";

export default function ResponseAndLimites() {
  const { t, i18n } = useTranslation();
  const isRtl = i18n.language === "ar";
  const [openDeleteModal, setOpenDeleteModal] = useState(false);
  const [deletedId, setDeletedId] = useState(null);
  const [isModalOpen, setModalOpen] = useState(false);

  const [page, setPage] = useState(0);
  const [loading, setLoading] = useState(false);
  const [clientReqList, setClientReqList] = useState([]);
  const [search, setSearch] = useState("");
  const [editData, setEditData] = useState({});
  const [mode, setMode] = useState("add");
  const [purpose, setPurpose] = useState("");
  const [category, setCategory] = useState("");
  const [purposeOptions, setPurposeOptions] = useState([]);

  const categoryList = [
    { id: 1, labelAr: "مشروع", labelEn: "Project", value: "PROJECT" },
    { id: 2, labelAr: "مخطط", labelEn: "Plan", value: "PLAN" },
  ];

  useEffect(() => {
    getLookupsList("UNIT_PURPOSE").then((res) => {
      setPurposeOptions(res?.data?.UNIT_PURPOSE || []);
    });
  }, []);

  const clientRequests = (
    pageNum = page,
    searchVal = search,
    categoryVal = category,
    purposeVal = purpose
  ) => {
    setLoading(true);
    getAskRequestsList(pageNum, searchVal, categoryVal, purposeVal)
      .then((res) => {
        setClientReqList(res.data);
        setLoading(false);
      })
      .catch(() => setLoading(false));
  };

  useEffect(() => {
    clientRequests(page, search, category, purpose);
  }, [page, search, category, purpose]);

  const handleChangePage = (__, newPage) => {
    setPage(newPage);
  };

  const handleDelete = (id) => {
    deleteAskRequest(id)
      .then((res) => {
        if (res?.data?.STATUS === "FAILED" || res?.data?.STATUS === "0") {
          toast.error(res?.data?.MESSAGE);
        } else {
          clientRequests(page, search, category, purpose);
          setOpenDeleteModal(false);
          toast.success(res?.data?.MESSAGE);
        }
      })
      .catch((err) => toast.error(err?.response?.data?.MESSAGE || err?.message));
  };

  const handleCloseModal = () => {
    setModalOpen(false);
    setEditData({});
  };

  const handleRefresh = () => {
    setPage(0);
    clientRequests(0, search, category, purpose);
  };
  return (
    <>
      <Grid container spacing={2} alignItems="center">
        <Grid justifyContent="start" display="flex" item xs={12} sm={4} md={3}>
          <SearchComponet onSearch={setSearch} />
        </Grid>
        {/* Category Filter */}
        <Grid item xs={12} sm={4} md={3}>
          <FormControl fullWidth>
            <Select
              displayEmpty
              value={category}
              onChange={(e) => {
                setCategory(e.target.value);
                setPage(0);
              }}
              sx={{ paddingX: "10px", borderRadius: "10px" }}
              renderValue={(selected) => {
                if (!selected)
                  return (
                    <Typography color="text.secondary">
                      {t("response_templates.add_ask_requests_type")}
                    </Typography>
                  );
                const item = categoryList.find((o) => o.value === selected);
                return (
                  <Box display="flex" alignItems="center" gap={2}>
                    <Typography margin="0">
                      {isRtl ? item?.labelAr : item?.labelEn}
                    </Typography>
                  </Box>
                );
              }}
              IconComponent={() => (
                <DropdownIcon style={{ width: "15px", height: "15px" }} />
              )}
            >
              <MenuItem value="">
                <Typography color="text.secondary">
                  {t("General.ALL")}
                </Typography>
              </MenuItem>
              {categoryList.map((item, index) => (
                <MenuItem key={index} value={item?.value}>
                  <Typography margin="0">
                    {isRtl ? item?.labelAr : item?.labelEn}
                  </Typography>
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </Grid>
        {/* Purpose Filter */}
        <Grid item xs={12} sm={4} md={3}>
          <FormControl fullWidth>
            <Select
              displayEmpty
              value={purpose}
              onChange={(e) => {
                setPurpose(e.target.value);
                setPage(0);
              }}
              sx={{ paddingX: "10px", borderRadius: "10px" }}
              renderValue={(selected) => {
                if (!selected)
                  return (
                    <Typography color="text.secondary">
                      {t("General.purpose")}
                    </Typography>
                  );
                const item = purposeOptions.find((o) => o.value === selected);
                return (
                  <Box display="flex" alignItems="center" gap={2}>
                    <Typography margin="0">
                      {isRtl ? item?.labelAr : item?.labelEn}
                    </Typography>
                  </Box>
                );
              }}
              IconComponent={() => (
                <DropdownIcon style={{ width: "15px", height: "15px" }} />
              )}
            >
              <MenuItem value="">
                <Typography color="text.secondary">
                  {t("General.ALL")}
                </Typography>
              </MenuItem>
              {purposeOptions.map((item, index) => (
                <MenuItem key={index} value={item?.value}>
                  <Typography margin="0">
                    {isRtl ? item?.labelAr : item?.labelEn}
                  </Typography>
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </Grid>
        <Grid justifyContent="end" display="flex" item xs={12} sm={4} md={3}>
          <Button
            onClick={() => {
              setEditData({});
              setMode("add");
              setModalOpen(true);
            }}
            style={{
              backgroundColor: "black",
              color: "white",
              borderRadius: "10px",
              padding: "21px 24px",
              width: "fit-content",
              height: "56px",
              marginBottom: "15px",
            }}
          >
            {" "}
            + {t("response_templates.add_project_type")}
          </Button>
        </Grid>
      </Grid>
      {loading ? (
        <Stack>
          <Skeleton height={100} />
          <Skeleton height={100} />
          <Skeleton height={100} />
          <Skeleton height={100} />
          <Skeleton height={100} />
          <Skeleton height={100} />
        </Stack>
      ) : (
        <CityReqTable
          handleChangePage={handleChangePage}
          page={page}
          requests={clientReqList}
          purposeOptions={purposeOptions}
          onDelete={(id) => {
            setDeletedId(id);
            setOpenDeleteModal(true);
          }}
          refreshApi={handleRefresh}
          onEdit={(e) => {
            setMode("edit");
            setModalOpen(true);
            setEditData(e);
          }}
        />
      )}
      {isModalOpen && (
        <AddOrEditModal
          open={isModalOpen}
          handleClose={handleCloseModal}
          data={editData}
          refreshApi={handleRefresh}
          mode={mode}
          purposeOptions={purposeOptions}
        />
      )}
      {openDeleteModal && (
        <ConfirmationModal
          handelClose={() => setOpenDeleteModal(false)}
          onUpdate={() => handleDelete(deletedId)}
          open={openDeleteModal}
        />
      )}
    </>
  );
}

